<script setup lang="ts">
import { DropdownMenuSub } from 'reka-ui';
</script>

<template>
    <DropdownMenuSub>
        <slot />
    </DropdownMenuSub>
</template>
